import React, {useState} from 'react';
import CheckBox from 'epic-diesel-form/src/components/form/CheckBox';
import {ConductDialog, AffiliateDialog, DialogLink} from '../../..';
import {useGetMessages} from '../../../../hooks';

// @ts-ignore
import styles from './EulaFormSection.pcss';

interface Props {
    messages: Record<string, string>;
    guardianAcknowledgment: boolean;
    guardianAccepted: boolean;
    acceptedAgreement: boolean;
    acceptedConduct: boolean;
    updateEulaStatus: (formKey: string, checked: boolean) => void;
}

const EulaFormSection: React.FC<Props> = ({
    guardianAcknowledgment,
    acceptedAgreement,
    acceptedConduct,
    guardianAccepted,
    updateEulaStatus
}) => {
    const [showAgreement, setShowAgreement] = useState(false);
    const [showConduct, setShowConduct] = useState(false);
    const messages = useGetMessages({
        title: 'epic.affiliate.signup.content_guidelines.title.v2',
        body: 'epic.affiliate.signup.content_guidelines.body.v2',
        requiredField: 'errors.com.epicgames.validation.required_field.v2',
        affiliate: {
            code: 'epic.affiliate.signup.creator_agreement.acknowledge.text.v2',
            args: [
                <DialogLink
                    key="affiliateLink"
                    code="epic.affiliate.signup.creator_agreement.acknowledge.linkText.v2"
                    onClick={() => setShowAgreement(true)}
                />
            ]
        },
        conduct: {
            code: 'epic.affiliate.signup.content_guidelines.acknowledge.text.v2',
            args: [
                <DialogLink
                    key="conductLink"
                    code="epic.affiliate.signup.content_guidelines.acknowledge.linkText.v2"
                    onClick={() => setShowConduct(true)}
                />
            ]
        },
        guardian: {
            code: 'epic.affiliate.signup.content_guidelines.guardian.acknowledge.v2',
            args: [
                <DialogLink key="guardianLink" code="epic.affiliate.signup.creator_agreement.v2" />
            ]
        }
    });

    const items = [
        {
            key: 'affiliate',
            name: 'agreementAccepted',
            value: acceptedAgreement
        },
        {
            key: 'conduct',
            name: 'eulaAccepted',
            value: acceptedConduct
        },
        guardianAcknowledgment && {
            key: 'guardian',
            name: 'guardianAccepted',
            value: guardianAccepted
        }
    ];

    return (
        <>
            <h2>
                {messages.title}
                {' *'}
            </h2>
            <p>{messages.body}</p>

            <div className={styles.eulaSection}>
                <ConductDialog open={showConduct} onClose={() => setShowConduct(false)} />
                <AffiliateDialog open={showAgreement} onClose={() => setShowAgreement(false)} />

                <div className={styles.eulaAccept}>
                    {items.map((item, i) => {
                        if (!item) return null;
                        return (
                            <CheckBox
                                key={i}
                                name={item.name}
                                validations="checked"
                                validationError={messages.requiredField}
                                value={item.value}
                                onChange={updateEulaStatus}>
                                {messages[item.key]}
                            </CheckBox>
                        );
                    })}
                </div>
            </div>
        </>
    );
};

export default React.memo(EulaFormSection);
